import { Switch } from '~/components/granular/switch/Switch';
import type { SwitchProps } from '~/components/granular/switch/Switch.types';
import { useFormatMessage } from '~/intl';
import { classNames } from '~/utils/styles';

export const PivotModeSwitch = ({ className, ...rest }: SwitchProps) => {
  const formatMessage = useFormatMessage();

  return (
    <Switch
      {...rest}
      className={classNames('items-center', className)}
      label={formatMessage({ id: 'common.pivotMode' })}
    />
  );
};
